export enum ERecommendationType {
  MENU = 'menu',
  CHECKOUT = 'checkout',
}
